import ScriptingEffect from './ScriptingEffect.js';
import {pipe} from './pipe.js';
import {alt} from './alt.js';
import {density} from './density.js';
import {gte} from './compare.js';
import {stats} from './stats.js';

class StatsEffect extends ScriptingEffect {
    constructor(track) {
        super("Stats", track);
        this.mem = {};
        this.clear();
    }

    isRealTime() { return true; }

    clear() {
        this.myScript = pipe(
            stats());
    }

    get script() {
        return this.myScript;
    }

    getCopy(track, ignoreId=true) {
        let fx = new StatsEffect(track);
        fx.fromJson(fx.getJson(), ignoreId);
        return fx;
    }
}


export default StatsEffect;
